import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=1ddc5626&scoped=true"
import script from "./ProfileDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileDetail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileDetail.vue?vue&type=style&index=0&id=1ddc5626&prod&lang=scss&scoped=true"
import style1 from "./ProfileDetail.vue?vue&type=style&index=1&id=1ddc5626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc5626",
  null
  
)

export default component.exports